import RootState from 'typings/RootState'
import { ConfigList } from './types'
import { Event } from '../../types/event'

export const selectDataList = (state: RootState): ConfigList =>
  state.adminSettingConfig.DataList

export const selectEvent = (state: RootState): Event =>
  state.adminSettingConfig.event

export const selectSorting = (state: RootState) =>
  state.adminSettingConfig.sorting
